import styled from "styled-components";
import { CharactersInfo } from "../TextField/TextField.styles";
import { ErrorLabel } from "./Error.styles";
export const StyledWrapper = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  ${({ indented }) => (indented ? "margin-left: 2.25rem;" : "")}
  ${({ isToggle }) => (isToggle ? "min-height: 2.5rem;" : "")}

  & > span:not(${CharactersInfo}, ${ErrorLabel}) {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2.5rem;
    width: 2.5rem;
    position: absolute;
    left: 0;
    bottom: 0;

    & > svg {
      height: 1rem;
    }
  }

  & span {
    pointer-events: none;
  }

  @media ${({ theme }) => theme.device.xsmall} {
    & > span:not(${CharactersInfo}, ${ErrorLabel}) {
      height: 2.75rem;
      width: 2.75rem;
    }
  }
  @media ${({ theme }) => theme.device.large} {
    & > span:not(${CharactersInfo}, ${ErrorLabel}) {
      height: 2.5rem;
      width: 2.5rem;
    }
  }

  & > span + label,
  & > span ~ input,
  & > span + select,
  & > span ~ select {
    margin-left: 2.5rem;
  }

  div > button {
    position: absolute;
    right: 0;
    bottom: 0;
  }

  div > span {
    position: absolute;
    right: 0;
    bottom: 0;
  }

  label {
    ${({ multiLine }) => multiLine
    ? "padding-top: 0.75rem; padding-bottom: 0.5rem;"
    : "padding-bottom: 0.25rem;"}
    ${({ type }) => type === "checkbox" || type === "checkboxGroup"
    ? "margin-right: auto;"
    : ""}
  }

  @supports (-moz-appearance: none) {
    button {
      ${({ type, values, name }) => { var _a; return type === "date" && ((_a = values === null || values === void 0 ? void 0 : values[name]) === null || _a === void 0 ? void 0 : _a.length) > 0 ? "display: none" : ""; }}
    }
  }

  ${({ isToggle, type, values, name, theme, indented }) => {
    var _a, _b;
    return isToggle
        ? `
      &:first-of-type {
        ${indented ? "margin-left: 0;" : ""};

        input + label {
          & > span {
            display: ${type === "checkboxGroup" && ((_a = values === null || values === void 0 ? void 0 : values[name]) === null || _a === void 0 ? void 0 : _a.length) >= 1
            ? "block"
            : ""};
          }

          &:after {
            ${type === "checkboxGroup" && ((_b = values === null || values === void 0 ? void 0 : values[name]) === null || _b === void 0 ? void 0 : _b.length) >= 1
            ? `background-color: ${theme.colors.grey15}`
            : ""};
          }
      }
    }`
        : "";
}}
`;
